/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { LocalDate } from "@freightsimple/time/branded-types";

import { mapValues } from "../runtime";
import type { GenerateProfitLossReportFilterOptionsSettledStatus } from "./GenerateProfitLossReportFilterOptionsSettledStatus";
import {
  GenerateProfitLossReportFilterOptionsSettledStatusFromJSON,
  GenerateProfitLossReportFilterOptionsSettledStatusFromJSONTyped,
  GenerateProfitLossReportFilterOptionsSettledStatusToJSON,
  GenerateProfitLossReportFilterOptionsSettledStatusToJSONTyped,
} from "./GenerateProfitLossReportFilterOptionsSettledStatus";
import type { GeoFilter } from "./GeoFilter";
import {
  GeoFilterFromJSON,
  GeoFilterFromJSONTyped,
  GeoFilterToJSON,
  GeoFilterToJSONTyped,
} from "./GeoFilter";

/**
 *
 * @export
 * @interface GenerateProfitLossReportFilterOptions
 */
export interface GenerateProfitLossReportFilterOptions {
  /**
   *
   * @type {GenerateProfitLossReportFilterOptionsSettledStatus}
   * @memberof GenerateProfitLossReportFilterOptions
   */
  settledStatus: GenerateProfitLossReportFilterOptionsSettledStatus;
  /**
   *
   * @type {boolean}
   * @memberof GenerateProfitLossReportFilterOptions
   */
  onlyIncludeLosses: boolean;
  /**
   *
   * @type {string}
   * @memberof GenerateProfitLossReportFilterOptions
   */
  leadSource?: string | null;
  /**
   *
   * @type {string}
   * @memberof GenerateProfitLossReportFilterOptions
   */
  companyId?: string | null;
  /**
   *
   * @type {string}
   * @memberof GenerateProfitLossReportFilterOptions
   */
  carrierIdentifier?: string | null;
  /**
   *
   * @type {string}
   * @memberof GenerateProfitLossReportFilterOptions
   */
  serviceIdentifier?: string | null;
  /**
   *
   * @type {LocalDate}
   * @memberof GenerateProfitLossReportFilterOptions
   */
  startDate?: LocalDate | null;
  /**
   *
   * @type {LocalDate}
   * @memberof GenerateProfitLossReportFilterOptions
   */
  endDate?: LocalDate | null;
  /**
   *
   * @type {string}
   * @memberof GenerateProfitLossReportFilterOptions
   */
  campaign?: string | null;
  /**
   *
   * @type {GeoFilter}
   * @memberof GenerateProfitLossReportFilterOptions
   */
  geoFilter?: GeoFilter | null;
  /**
   *
   * @type {number}
   * @memberof GenerateProfitLossReportFilterOptions
   */
  minMargin?: number | null;
  /**
   *
   * @type {number}
   * @memberof GenerateProfitLossReportFilterOptions
   */
  maxMargin?: number | null;
}

/**
 * Check if a given object implements the GenerateProfitLossReportFilterOptions interface.
 */
export function instanceOfGenerateProfitLossReportFilterOptions(
  value: object,
): value is GenerateProfitLossReportFilterOptions {
  if (!("settledStatus" in value) || value["settledStatus"] === undefined)
    return false;
  if (
    !("onlyIncludeLosses" in value) ||
    value["onlyIncludeLosses"] === undefined
  )
    return false;
  return true;
}

export function GenerateProfitLossReportFilterOptionsFromJSON(
  json: any,
): GenerateProfitLossReportFilterOptions {
  return GenerateProfitLossReportFilterOptionsFromJSONTyped(json, false);
}

export function GenerateProfitLossReportFilterOptionsFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): GenerateProfitLossReportFilterOptions {
  if (json == null) {
    return json;
  }
  return {
    settledStatus: GenerateProfitLossReportFilterOptionsSettledStatusFromJSON(
      json["settledStatus"],
    ),
    onlyIncludeLosses: json["onlyIncludeLosses"],
    leadSource: json["leadSource"] == null ? undefined : json["leadSource"],
    companyId: json["companyId"] == null ? undefined : json["companyId"],
    carrierIdentifier:
      json["carrierIdentifier"] == null ? undefined : json["carrierIdentifier"],
    serviceIdentifier:
      json["serviceIdentifier"] == null ? undefined : json["serviceIdentifier"],
    startDate: json["startDate"] == null ? undefined : json["startDate"],
    endDate: json["endDate"] == null ? undefined : json["endDate"],
    campaign: json["campaign"] == null ? undefined : json["campaign"],
    geoFilter:
      json["geoFilter"] == null
        ? undefined
        : GeoFilterFromJSON(json["geoFilter"]),
    minMargin: json["minMargin"] == null ? undefined : json["minMargin"],
    maxMargin: json["maxMargin"] == null ? undefined : json["maxMargin"],
  };
}

export function GenerateProfitLossReportFilterOptionsToJSON(
  json: any,
): GenerateProfitLossReportFilterOptions {
  return GenerateProfitLossReportFilterOptionsToJSONTyped(json, false);
}

export function GenerateProfitLossReportFilterOptionsToJSONTyped(
  value?: GenerateProfitLossReportFilterOptions | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    settledStatus: GenerateProfitLossReportFilterOptionsSettledStatusToJSON(
      value["settledStatus"],
    ),
    onlyIncludeLosses: value["onlyIncludeLosses"],
    leadSource: value["leadSource"],
    companyId: value["companyId"],
    carrierIdentifier: value["carrierIdentifier"],
    serviceIdentifier: value["serviceIdentifier"],
    startDate: value["startDate"],
    endDate: value["endDate"],
    campaign: value["campaign"],
    geoFilter: GeoFilterToJSON(value["geoFilter"]),
    minMargin: value["minMargin"],
    maxMargin: value["maxMargin"],
  };
}
